import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send } from 'lucide-react';
import '../styles/ContactForm.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    project_type: '',
    budget: '',
    timeline: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success('Thank you! We\'ll get back to you within 24 hours.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        project_type: '',
        budget: '',
        timeline: '',
        message: ''
      });
    } catch (error) {
      toast.error('Failed to submit. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={loading}
            data-testid="contact-name-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
            data-testid="contact-email-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            disabled={loading}
            data-testid="contact-phone-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="company">Company</label>
          <input
            type="text"
            id="company"
            name="company"
            value={formData.company}
            onChange={handleChange}
            disabled={loading}
            data-testid="contact-company-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="project_type">Project Type</label>
          <select
            id="project_type"
            name="project_type"
            value={formData.project_type}
            onChange={handleChange}
            disabled={loading}
            data-testid="contact-project-type-select"
          >
            <option value="">Select a service</option>
            <option value="App Development">App Development</option>
            <option value="Web Development">Web Development</option>
            <option value="SEO & Growth">SEO & Growth</option>
            <option value="UI/UX Design">UI/UX Design</option>
            <option value="QA & Testing">QA & Testing</option>
            <option value="AI/ML">AI/ML</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="budget">Budget Range</label>
          <select
            id="budget"
            name="budget"
            value={formData.budget}
            onChange={handleChange}
            disabled={loading}
            data-testid="contact-budget-select"
          >
            <option value="">Select budget range</option>
            <option value="< $10k">&lt; $10k</option>
            <option value="$10k - $25k">$10k - $25k</option>
            <option value="$25k - $50k">$25k - $50k</option>
            <option value="$50k - $100k">$50k - $100k</option>
            <option value="> $100k">&gt; $100k</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="timeline">Timeline</label>
          <select
            id="timeline"
            name="timeline"
            value={formData.timeline}
            onChange={handleChange}
            disabled={loading}
            data-testid="contact-timeline-select"
          >
            <option value="">Select timeline</option>
            <option value="ASAP">ASAP</option>
            <option value="1-3 months">1-3 months</option>
            <option value="3-6 months">3-6 months</option>
            <option value="6+ months">6+ months</option>
          </select>
        </div>

        <div className="form-group full-width">
          <label htmlFor="message">Project Details *</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
            disabled={loading}
            data-testid="contact-message-textarea"
          />
        </div>
      </div>

      <button type="submit" className="btn btn-primary btn-large submit-button" disabled={loading} data-testid="contact-submit-button">
        {loading ? (
          <>
            <div className="spinner" />
            Sending...
          </>
        ) : (
          <>
            Send Message
            <Send size={20} />
          </>
        )}
      </button>
    </form>
  );
};

export default ContactForm;